import { render, staticRenderFns } from "./profile-detail.vue?vue&type=template&id=5e351a80&scoped=true&"
import script from "./profile-detail.vue?vue&type=script&lang=js&"
export * from "./profile-detail.vue?vue&type=script&lang=js&"
import style0 from "./profile-detail.vue?vue&type=style&index=0&id=5e351a80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e351a80",
  null
  
)

export default component.exports